import { createContext } from 'react';
import uuid from 'react-uuid';
import { decorate, observable, action, toJS } from 'mobx';

import api from '../api';
import * as fn from '../utilities/_functions';

export class FormInputCreate {
    id = null;
    data = {
        formTemplateId: null,
        key: null,
        name: null,
        descriptionHtml: null,
        label: null,
        type: null,
        isRequired: false,
        metadata: null,
    };
    isReady = false;
    isSaving = false;
    hasUnsavedChanges = false;

    cancelFormInputCreate = null;
    cancelFormInputGet = null;

    initialize = (formTemplateId) => {
        this.clear();
        this.id = uuid();
        this.data.formTemplateId = formTemplateId;
        this.isReady = true;
    }

    setMetadata = (key, value) => {
        let metadata = this.data.metadata;

        if (!metadata) {
            metadata = {};
        }

        if (!metadata.hasOwnProperty(key)) {
            metadata = { ...metadata, ...{ [key]: value } };
        } else {
            metadata[key] = value;
        }

        this.data.metadata = metadata;
    }

    removeMetadata = (key) => {
        let metadata = this.data.metadata;

        if (metadata && metadata.hasOwnProperty(key)) {
            delete metadata[key];
        }
    }

    getMetadata = (key) => {
        if (!this.data.metadata) return undefined;
        return this.data.metadata[key];
    }

    clone = (id) => {
        // Cloning an existing form input.
        // initialize previously store the formTemplateId. But the clear() will erase it.
        const tmpFormTemplateId = this.data.formTemplateId;
        const that = this;
        this.clear();
        this.isLoading = true;

        return new Promise((resolve, reject) => {
            api.FormInputs.get(id, (c) => { that.cancelFormInputGet = c })
                .then(({ data }) => {
                    that.data = data;
                    that.data.id = null;
                    that.data.formTemplateId = tmpFormTemplateId;

                    resolve();
                })
                .catch(() => {
                    reject();
                })
                .finally(() => {
                    that.isLoading = false;
                })
        })
    }

    save = (notify) => {
        const that = this;

        if (!!notify) {
            this.isSaving = true;
        }

        return new Promise((resolve, reject) => {
            let option = toJS(that.data);

            if (that.hasUnsavedChanges) {
                api.FormInputs.create(option, (c) => { that.cancelFormInputCreate = c })
                    .then(({ data }) => {
                        that.id = data.id;
                        that.hasUnsavedChanges = false;
                        option.id = data.id;
                        resolve(option);
                    })
                    .catch(() => {
                        reject();
                    })
                    .finally(() => {
                        that.isSaving = false;
                    })
            } else {
                that.hasUnsavedChanges = false;
                that.isSaving = false;
            }
        })
    }

    clear = () => {
        this.id = null;
        this.data.formTemplateId = null;
        this.data.key = null;
        this.data.name = null;
        this.data.descriptionHtml = null;
        this.data.label = null;
        this.data.type = null;
        this.data.isRequired = false;
        this.data.metadata = null;
        this.isReady = false;
        this.isSaving = false;
        this.hasUnsavedChanges = false;

        if (fn.isFunction(this.cancelFormInputCreate)) {
            this.cancelFormInputCreate();
            this.cancelFormInputCreate = null;
        }

        if (fn.isFunction(this.cancelFormInputGet)) {
            this.cancelFormInputGet();
            this.cancelFormInputGet = null;
        }
    }
}

decorate(FormInputCreate, {
    id: observable,
    data: observable.deep,
    isReady: observable,
    isSaving: observable,
    initialize: action,
    setMetadata: action,
    removeMetadata: action,
    getMetadata: action,
    hasUnsavedChanges: observable,
    save: action,
    clone: action,
    clear: action,
})

export default createContext(new FormInputCreate());